import { useMemo } from 'react';
import { ContactOverviewItemProps } from '../contact-overview-item';

export const useHasDefinedItems = (
  items: ContactOverviewItemProps[],
  moreItems: ContactOverviewItemProps[]
) => {
  return useMemo(
    () =>
      items.some((item) => item.value !== undefined && item.value !== null) ||
      moreItems.some((item) => item.value !== undefined && item.value !== null),
    [items, moreItems]
  );
};
